<template>
  <b-button
    :class="['icon-button is-icon', {'outlined': outlined}, size]"
    type="is-text"
    :size="size"
    :loading="loading"
    :type="color"
    @click="$emit('click', $event)"
  >
    <icon-default :icon="icon" :size="size" :color="color"></icon-default>
  </b-button>
</template>

<script>
export default {
  name: "ButtonIcon",
  props: {
    size: {
      type: String,
      default: 'is-small'
    },
    icon: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
    },
    outlined: {
      type: Boolean,
      default: false
    },
  }
}
</script>
